(ns frontend.ui.page.lp-report-editor.step-4-pending-approval.sub
  (:require
   [frontend.ui.page.lp-report-editor.sub :as editor-sub]
   [re-frame.core :as rf]
   [clojure.set :as set]
   [common.schema.entities.lp-portal.lp-report :as lp-report]))

(def report-tab-path (conj editor-sub/editor-path :pending-approval-report-tab))

(rf/reg-sub
 ::approve-access?
 (fn [db]
   (let [account-id (get-in db editor-sub/account-id-path)
         team-memberships (get-in db editor-sub/team-memberships-ids-path)
         report (get-in db editor-sub/report-path)
         admin? (get-in db editor-sub/reporting-admin?-path)
         owner? (some (set/union #{account-id} (set team-memberships))
                      (:lp-report/process-owners report))]
     (lp-report/can-do-final-approval? {:fund-report     report
                                        :account-id      account-id
                                        :team-ids        team-memberships
                                        :admin-or-owner? (or owner? admin?)}))))